import Grid from "@mui/material/Grid";
import { LabelField, Text } from "components";
import Button from "components/button/Button.jsx";
import HebrewDatePicker from "components/DatePicker/HebrewDatePicker";
import InfoTooltip from "components/InfoTooltip";
import { InputField } from "components/InputField/InputField";
import { VirtualKeyboard } from "components/keyboard";
import MyButton from "components/MyButton";
import SwitchComp from "components/switch";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat.js";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router-dom";
import { DateFormetContext } from "../../../app/App.js";

const DeceacedDetails = ({
  drawerDisplay,
  setOpenDrawer,
  setFieldValue,
  onSubmit,
  yahrziet,
  source = "",
  ...props
}) => {
  const [openKeyboard, setOpenKeyboard] = useState(false);
  const [date, setDate] = useState("");
  const { id } = useParams();
  const [hebrewDate, setHebrewDate] = useState("");
  const [dateChanged, setDateChanged] = useState(false);
  const formik = { ...props };
  const [prevFormikValues] = useState(yahrziet);

  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );





  const handleDisabledSaveButton = () => {
    let result;
    if (
      formik.values?.firstName === prevFormikValues?.firstName &&
      formik.values?.lastName === prevFormikValues?.lastName &&
      formik.values?.date_of_death === prevFormikValues?.date_of_death &&
      formik.values?.hebrew_name === prevFormikValues.hebrew_name &&
      formik.values?.before_sunset === prevFormikValues.before_sunset &&
      formik.values?.hebrew_date === prevFormikValues.hebrew_date
    ) {
      result = true;
    } else {
      result = false;
    }
    return result;
  };


  const addDays = (date, days = 1) => {
    if (date) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    return "";
  };

  useEffect(() => {
    handleDisabledSaveButton();
  }, [formik.values]);

  const HebrewDate = (checkEnabel) => {
    return (
      <HebrewDatePicker
        handleChange={(e) => setHebrewDate(e)}
        date={date ? moment(date).utcOffset("+0100").format("MM/DD/YYYY") : ""}
        name="hebrew_date"
        checkEnabel={checkEnabel}
        title="Hebrew date of death"
        setHebrewDate={setHebrewDate}
        defaultValue={(dateChanged && source === "drawer") ? "" : formik.values?.default_hebrew_date}
        hint="Calculated automatically based on the Date of death and the After sunset toggle. The Hebrew date of death can only be changed by picking a different (English/Gregorian) Date of death."
      />
    );
  };
  function contains_heb(str) {
    return /[\u0590-\u05FF]/.test(str.slice(-1));
  }

  useEffect(() => {
    setFieldValue("hebrew_date", hebrewDate);
  }, [hebrewDate]);
  useEffect(() => {
    if (id) {
      setFieldValue("account", id);
    }
  }, [id]);

  useEffect(() => {
    const hebrew =
      props.values.before_sunset == true && props.values.date_of_death
        ? addDays(props.values.date_of_death)
        : props.values.date_of_death;
    if (!hebrew) return;
    setDate(new Date(hebrew).toUTCString());
  }, [props.values.date_of_death]);
  const handleKeyboardChange = (e) => {
    setFieldValue("hebrew_name", e);
  };

  let newDate = moment(newDate).format("YYYY-MM-DD");

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    setFieldValue(name, date);
    return date;
  }
  return (
    <div
      className={
        drawerDisplay ? "deceaced-details p-8" : "deceaced-details pt-12"
      }
    >
      {!drawerDisplay && (
        <div className="title">
          <Text className="sub-title">Deceased details</Text>
          <p className="yah-note">Please complete the details below</p>
        </div>
      )}
      <div className={drawerDisplay ? "mb-10" : "my-10"}>
        <Grid container spacing={drawerDisplay ? 2.5 : 5}>
          <Grid item xs={drawerDisplay ? 12 : 6}>
            <div className="deceased-details">
              <InputField
                placeholder="First Name"
                title="First Name"
                titleStyle={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                name="firstName"
                isOptional={false}
                type="text"
                formik={formik}
                value={formik.values?.firstName}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                flexDirection="column"
              />
            </div>
          </Grid>
          <Grid item xs={drawerDisplay ? 12 : 6}>
            <div className="deceased-details">
              <InputField
                placeholder="Last Name"
                title="Last Name"
                titleStyle={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                name="lastName"
                isOptional={false}
                type="text"
                formik={formik}
                value={formik.values?.lastName}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                flexDirection="column"
              />
            </div>
          </Grid>
          <Grid item xs={drawerDisplay ? 12 : 6}>
            <div className="deceased-details deceased-hebrew-name">
              {openKeyboard && (
                <VirtualKeyboard
                  handleChange={handleKeyboardChange}
                  setOpenKeyboard={setOpenKeyboard}
                  value={formik.values?.hebrew_name}
                />
              )}
              <InputField
                setOpenKeyboard={setOpenKeyboard}
                openKeyboard={openKeyboard}
                placeholder="Click on icon to type"
                title="Deceased Hebrew name"
                titleStyle={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                name="hebrew_name"
                isOptional={false}
                type="text"
                formik={formik}
                styleWrapper={{ position: "relative" }}
                value={formik.values?.hebrew_name}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                flexDirection="column"
                onChange={(e) => {
                  let result = contains_heb(e.target.value);
                  setFieldValue("hebrew_name", e.target.value);
                }}
                dir={formik.values?.hebrew_name ? "rtl" : "ltr"}
              />
            </div>
          </Grid>
          <Grid item xs={drawerDisplay ? 12 : 6}>
            <div className="deceased-date">
              <LabelField title="Date of death" color="black" style={{ marginBottom: 0 }} />
              <DatePicker
                showIcon
                placeholderText={getDateFormat()}
                dateFormat={getDateFormatForDatePicket()}
                maxDate={new Date()}
                customInput={
                  <InputField
                    name="date"
                    isDate={true}
                    isOptional={false}
                    type="text"
                    formik={formik}
                    styleWrapper={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                    flexDirection="column"
                  />
                }
                selected={
                  formik?.values?.date_of_death &&
                  convertUTCToLocalDate(formik?.values?.date_of_death)
                }
                onChange={(e) => {
                  setFieldValue(`date_of_death`, e);
                  convertLocalToUTCDate(e, `date_of_death`);
                  setDateChanged(true);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={drawerDisplay ? 12 : 6}>
            <div className="deceased-details">
              <SwitchComp
                checked={props.values.before_sunset}
                handleChange={() => {
                  setFieldValue("before_sunset", !props.values.before_sunset);
                  props.setFieldTouched("before_sunset", true);
                  let update = new Date(date);
                  if (!props.values.before_sunset == true) {
                    update.setDate(update.getDate() + 1);
                    setDate(update);
                  }
                  if (!props.values.before_sunset == false) {
                    update.setDate(update.getDate() - 1);
                    setDate(update);
                  }
                  setDateChanged(true);
                }}
                className="mr-0"
              />
              <LabelField
                title="After sunset"
                color="black"
                style={{ alignSelf: "center", marginRight: "0" }}
              />
              <InfoTooltip text="Turn this on if the death occurred after sunset on the given date — in the Hebrew calendar that counts as the next Hebrew day, so the calculated Hebrew date shifts forward by one day." style={{ alignSelf: 'center', marginLeft: '6px', marginRight: '15px', marginBottom: '4px', transform: 'translateY(-2px)' }} />
            </div>
          </Grid>
          <Grid item xs={drawerDisplay ? 12 : 6}>
            <div
              className={`${drawerDisplay ? "col-sm-12" : "col-sm-6"} hebDate`}
            >
              <HebrewDate />
            </div>
          </Grid>
        </Grid>

        {drawerDisplay && (
          <div className="mt-4 btn-flex">
            <Button
              onClick={onSubmit}
              disabled={
                formik.values?.firstName === yahrziet?.firstName &&
                formik.values?.lastName === yahrziet?.lastName &&
                formik.values?.date_of_death === yahrziet?.date_of_death &&
                formik.values?.hebrew_name === yahrziet?.hebrew_name_of_Death &&
                formik.values?.before_sunset === yahrziet?.before_sunset &&
                formik.values?.hebrew_date === yahrziet?.hebrew_date_of_death
              }
              style={{ marginBottom: 20, minWidth: "100px" }}
              size="md"
              variant="primary"
            >
              <span>Save</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeceacedDetails;
